var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page center intro"},[_c('h1',{staticClass:"tit"},[_c('b',[_c('a',{on:{"click":function($event){return _vm.seleccionarIdioma('es')}}},[_vm._v("hola")]),_vm._v(" / "),_c('a',{staticClass:"en",on:{"click":function($event){return _vm.seleccionarIdioma('en')}}},[_vm._v("hello")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }